/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { AnagraficaIconeDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce tutti gli anagraficaColori
 * @summary Restituisce tutti gli anagraficaColori
 */
export const getAnagraficaIcone = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AnagraficaIconeDTO[]>(
    {
      url: `/framework-cfg-procedimenti/anagrafica-icone`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetAnagraficaIconeQueryKey = () =>
  [`/framework-cfg-procedimenti/anagrafica-icone`] as const;

export const getGetAnagraficaIconeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnagraficaIcone>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnagraficaIcone>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getAnagraficaIcone>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnagraficaIconeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnagraficaIcone>>
  > = ({ signal }) => getAnagraficaIcone(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetAnagraficaIconeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnagraficaIcone>>
>;
export type GetAnagraficaIconeQueryError = ErrorType<unknown>;

/**
 * @summary Restituisce tutti gli anagraficaColori
 */
export const useGetAnagraficaIcone = <
  TData = Awaited<ReturnType<typeof getAnagraficaIcone>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnagraficaIcone>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnagraficaIconeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
